import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { 
  Button, 
  TextField, 
  Card, 
  CardContent, 
  Box, 
  Typography, 
  Container,
  CssBaseline,
  LinearProgress
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Lock } from "@mui/icons-material";

const theme = createTheme({
  palette: {
    primary: {
      main: '#B3A6D2', // Cor principal do site
      contrastText: '#2A2252',
    },
    secondary: {
      main: '#6C5B7B', // Cor complementar
    },
    error: {
      main: '#C44536', // Cor para ações perigosas
    },
  },
  shape: {
    borderRadius: 4, // Bordas mais quadradas
  },
});

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
    setLoading(true);
    try {
      const response = await fetch("http://localhost:5000/api/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password })
      });
      
      const data = await response.json();
      if (response.ok) {
        localStorage.setItem("token", data.token); // Armazena o token
        navigate("/dashboard");
      } else {
        alert(data.message || "Credencials invàlides");
      }
    } catch (error) {
      alert("Error en intentar fer login");
    } finally {
      setLoading(false);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container component="main" maxWidth="xs">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            minHeight: '100vh',
            justifyContent: 'center',
            p: 2
          }}
        >
          <Card
            elevation={0}
            sx={{
              width: '100%',
              p: 3,
              border: `1px solid ${theme.palette.divider}`,
            }}
          >
            <Box sx={{ 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center',
              mb: 3
            }}>
              <Lock sx={{ 
                fontSize: 40,
                color: theme.palette.primary.main,
                mb: 1
              }}/>
              <Typography 
                component="h1" 
                variant="h5"
                sx={{
                  fontWeight: 600,
                  color: theme.palette.primary.dark
                }}
              >
                Accés al Panell
              </Typography>
            </Box>

            {loading && <LinearProgress sx={{ mb: 2 }} />}

            <Box component="form" noValidate>
              <TextField
                margin="normal"
                required
                fullWidth
                label="Usuari"
                variant="outlined"
                autoFocus
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                sx={{ mb: 2 }}
              />

              <TextField
                margin="normal"
                required
                fullWidth
                label="Contrasenya"
                type="password"
                variant="outlined"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                sx={{ mb: 3 }}
              />

              <Button
                fullWidth
                variant="contained"
                onClick={handleLogin}
                disabled={loading}
                sx={{
                  py: 1.5,
                  fontSize: '0.9rem',
                  textTransform: 'none',
                  '&:hover': {
                    backgroundColor: theme.palette.primary.dark
                  }
                }}
              >
                {loading ? 'Accedint...' : 'Accedir'}
              </Button>
            </Box>
          </Card>

          <Box sx={{ mt: 3, textAlign: 'center' }}>
            <Typography variant="body2" color="textSecondary">
              © {new Date().getFullYear()} Panell Administratiu
            </Typography>
          </Box>
        </Box>
      </Container>
    </ThemeProvider>
  );
}